import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { AiOutlineMail } from 'react-icons/ai';
import { BsPencil } from 'react-icons/bs';
import { TbLicense } from 'react-icons/tb';
import { useDispatch, useSelector } from 'react-redux';
import { Field, Formik, Form as FormikForm } from 'formik';
import { useEffect } from 'react';
import ButtonPrimarySubmit from 'utils/buttons/ButtonPrimarySubmit';
import { editRealEstateSchema } from '../validations/editRealEstateSchema';
import { updateRealEstate } from 'redux/realEstateSlice';

const EditRealEstateData = () => {
  const realEstateData = useSelector(state => state.realEstate.data);
  const dispatch = useDispatch();

  const initialValues = {
    name: realEstateData.name || '',
    matricula: realEstateData.matricula || '',
    email: realEstateData.email || ''
  };

  return (
    <Card className="bg-white">
      <Card.Header className="border-bottom">
        <Card.Title>Ficha de Información</Card.Title>
      </Card.Header>

      <Card.Body>
        {realEstateData && (
          <Row className="g-3">
            <Col xs={12}>
              <Formik
                initialValues={initialValues}
                onSubmit={values => {
                  dispatch(updateRealEstate(realEstateData.id, values));
                }}
                validationSchema={editRealEstateSchema}
              >
                {({ errors, touched, setValues, values }) => {
                  useEffect(() => {
                    setValues(initialValues);
                  }, [realEstateData]);

                  return (
                    <FormikForm>
                      <Row className="g-3">
                        <Form.Group>
                          <Form.Label>
                            <BsPencil size={16} /> Nombre:
                          </Form.Label>
                          <Form.Control
                            as={Field}
                            name="name"
                            isInvalid={touched.name && !!errors.name}
                            type="input"
                            placeholder={values.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>

                          <Form.Label className="mt-3">
                            <TbLicense size={18} /> Matrícula:
                          </Form.Label>
                          <Form.Control
                            as={Field}
                            name="matricula"
                            type="input"
                            placeholder={values.matricula}
                            disabled
                          />

                          <Form.Label className="mt-3">
                            <AiOutlineMail size={18} /> Email:
                          </Form.Label>
                          <Form.Control
                            as={Field}
                            name="email"
                            isInvalid={touched.email && !!errors.email}
                            type="input"
                            placeholder={values.email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Col xs={12}>
                          <ButtonPrimarySubmit
                            text="Guardar cambios"
                            className="w-100"
                          />
                        </Col>
                      </Row>
                    </FormikForm>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default EditRealEstateData;
